import { translate } from "../TranslateStringValue";

const Ajv = require("ajv");

const ajv = new Ajv();

ajv.addKeyword('isRequired', {
    type: 'string',
    validate: function validate(schema, data) {
        if (data?.length > 0) {
            return true;
        }
        validate.errors = [
            {
                keyword: 'isRequired',
                message: "Error",
                params: { keyword: 'isRequired' },
            },
        ];
        return false;
    },
    errors: true,
});

ajv.addKeyword('isMatchedRegex', {
    type: 'string',
    validate: function validate(schema, data) {
        const regex = new RegExp(schema.regex)
        if (regex.test(data)) {
            return true;
        }
        validate.errors = [
            {
                keyword: 'isMatchedRegex',
                message: "Error",
                params: { keyword: 'isMatchedRegex' },
            },
        ];
        return false;
    },
    errors: true,
});

ajv.addKeyword('isCommaSeperatedEmail', {
    type: 'string',
    validate: function validate(schema, data) {
        if (data.length === 0) return true

        //const emailRegex = new RegExp("^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$")
        const emails = data.split(",")
        let valid = 0
        for (let email of emails) {
            if (/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(email)) {
                valid += 1
            }
            else {
                break
            }
        }
        if (valid === emails.length) {
            return true
        }
        validate.errors = [
            {
                keyword: 'isMatchedRegex',
                message: "Error",
                params: { keyword: 'isMatchedRegex' },
            },
        ];
        return false;
    },
    errors: true,
});

const generateValidationSchema = (schemaData) => {
    let schema = {
        [schemaData.name]: {
            type: "string"
        }
    }

    if (translate(schemaData.requis)) {
        schema = {
            ...schema,
            [schemaData.name]: {
                ...schema[schemaData.name],
                isRequired: { required: true }
            }
        }
    }

    if (schemaData.requis_regexp.length > 0) {
        schema = {
            ...schema,
            [schemaData.name]: {
                ...schema[schemaData.name],
                isMatchedRegex: { regex: schemaData.requis_regexp }
            }
        }
    }

    if (schemaData.isEmailCommaSeperated) {
        schema = {
            ...schema,
            [schemaData.name]: {
                ...schema[schemaData.name],
                isCommaSeperatedEmail: { required: true }
            }
        }
    }

    return {
        type: "object",
        properties: schema
    }
}

const ValidateInput = (schemaData, data) => {
    const schema = generateValidationSchema(schemaData)
    const validate = ajv.compile(schema)
    return validate(data)
}

export default ValidateInput;
